import { useReducedMotion } from 'framer-motion';

const useMobileNavbarMenuAnimation = () => {
  // a11y prefers reduced motion motion alternative
  const shouldReduceMotion = useReducedMotion();

  const menuVariants = {
    open: {
      opacity: 1,
      display: 'block',
    },
    closed: {
      opacity: 0,
      transitionEnd: {
        display: 'none',
      },
    },
  };

  const linksVariants = {
    open: {
      transition: {
        staggerChildren: shouldReduceMotion ? 0 : 0.09,
        delayChildren: shouldReduceMotion ? 0 : 0.12,
      },
    },
    closed: {
      transition: {
        delayChildren: shouldReduceMotion ? 0 : 0.3,
      },
    },
  };

  const linkItemVariants = {
    open: {
      y: 0,
      opacity: 1,
      transition: { stiffness: 1000, velocity: -100 },
    },
    closed: {
      y: shouldReduceMotion ? 0 : 24,
      opacity: 0,
      transition: {
        y: { stiffness: 1000 },
      },
    },
  };

  const actionsVariants = {
    open: {
      transition: {
        when: 'beforeChildren',
        delayChildren: shouldReduceMotion ? 0 : 0.7,
      },
    },
  };

  const actionItemVariants = {
    open: {
      opacity: 1,
    },
    closed: {
      opacity: 0,
    },
  };

  return {
    menuVariants,
    linksVariants,
    linkItemVariants,
    actionsVariants,
    actionItemVariants,
  };
};

export default useMobileNavbarMenuAnimation;
